import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { ConformComponent } from '../../conform/conform.component';
import { PatientService, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-uservalidation',
  templateUrl: './uservalidation.component.html',
  styleUrls: ['./uservalidation.component.css', './otpinput.scss']
})
export class UservalidationComponent implements OnInit {
  error: string;
  type: string;
  setmask: string;
  show: boolean;
  public timealert = environment.timelimit;
  public Patpro = {
    otpassword: "",
    otpState: "",
    username: "",
    code: '1'
  }
  otpid: any;
  expires: MatDialogRef<ConformComponent>;
  showOtpValidation: any = false
  showotp: any = false
  patid: any;
  welcome: any;
  modalRef: any;
  resdata: any;
  sotp: string;
  showOtpComponent = true;
  @ViewChild('ngOtpInput') ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };
  patdetails: any;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    private patientservice: PatientService,
    private userService: UserService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private toast: ToastrService,
    private nav: Router,
    private dialog: MatDialog,
    private translate: TranslateService
  ) { 
    this.translate.setDefaultLang(userService.defaultLang);
  }

  ngOnInit() {
    // ////console.log("id");

    this.patientservice.changeNav(window.localStorage['randId'])
    if (window.localStorage['status'] == 'forgotlink') {
      if (window.localStorage['mail']) {
        this.userService.forgotUserInfo(window.localStorage['mail'])
          .subscribe(
            data => {
              if (data) {
                this.showOtpValidation = true
                this.patdetails = data;
                this.patdetails.patientName = data.firstName + data.lastName;
                this.patdetails.email = this.patdetails.userName
                if (this.patdetails.email && !this.patdetails.phone) {
                  this.patdetails.hideEmail = this.hideemail(this.patdetails.email)
                  this.type = "email"
                  this.userotp = "email"
                  this.otpdevice = "email"
                  this.showotp = true;
                  this.error = ''
                  this.reg();
                } else if (!this.patdetails.email && this.patdetails.phone) {
                  this.patdetails.hidePhone = this.hidephone(this.patdetails.phone)
                  this.type = "number"
                  this.userotp = "phone"
                  this.otpdevice = "sms"
                  this.showotp = true;
                  this.error = ''
                  this.reg();
                } else if (this.patdetails.email && this.patdetails.phone) {
                  this.patdetails.hideEmail = this.hideemail(this.patdetails.email)
                  this.patdetails.hidePhone = this.hidephone(this.patdetails.phone)
                  this.type = "email"
                  this.userotp = ""
                  this.otpdevice = "both"
                  this.error = ''
                  // this.reg();
                }
              }
            })
      }
    }
    else {
      this.patientservice
        .getwelcomepat(window.localStorage['randId'])
        .subscribe(
          data => {

            //////console.log(data);
            if (data.status == 'failure') {
              this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
              this.expires.componentInstance.message = data.message;
            }
            else {
              this.showOtpValidation = true;
              this.patdetails = data
              if (this.patdetails.email && !this.patdetails.phone) {
                this.patdetails.hideEmail = this.hideemail(this.patdetails.email)
                this.type = "email"
                this.userotp = "email"
                this.otpdevice = "email"
                this.showotp = true;
                this.reg();
                this.error = ''
              } else if (!this.patdetails.email && this.patdetails.phone) {
                this.patdetails.hidePhone = this.hidephone(this.patdetails.phone)
                this.type = "number"
                this.userotp = "phone"
                this.otpdevice = "sms"
                this.showotp = true;
                this.reg();
                this.error = ''
              } else if (this.patdetails.email && this.patdetails.phone) {
                this.patdetails.hideEmail = this.hideemail(this.patdetails.email)
                this.patdetails.hidePhone = this.hidephone(this.patdetails.phone)
                this.type = "email"
                this.userotp = ""
                this.otpdevice = "both"
                this.error = ''
              }
            }
          })
    }
  }
  replacefunction(gp2) {
    for (let i = 0; i < 4; i++) {
      gp2 += "*";
    } return gp2;

  }
  replaceemail(email, i) {
    let self = this
    if (i == 0) {
      return email.replace(/(.{0})(.*)(?=@)/,
        function (gp1, gp2, gp3) {
          return self.replacefunction(gp2)
        })
    } else if (i == 1) {
      return email.replace(/(.{1})(.*)(?=@)/,
        function (gp1, gp2, gp3) {
          return self.replacefunction(gp2)
        });
    } else if (i == 3) {
      return email.replace(/(.{3})(.*)(?=@)/,
        function (gp1, gp2, gp3) {
          return self.replacefunction(gp2)
        });
    } else {
      return email.replace(/(.{6})(.*)/,
        function (gp1, gp2, gp3) {
          return self.replacefunction(gp2)
        });
    }
  }
  hideemail(email) {
    let mail = email.split('@')
    if (mail[0].length < 3) {
      if (mail[0].length == 0) {
        return this.replaceemail(email, 0)
      }
      else {
        return this.replaceemail(email, 1)
      }
    } else {
      return this.replaceemail(email, 3)
    }

  };
  hidephone(email) {
    //email = email.slice(0, -4)
    return this.replaceemail(email, 6)
  };
  validotp: any;
  otpType: any
  reg() {
    this.validotp = ''
    this.Patpro.otpassword = ''
    this.otpType = 'activation-otp'
    if (window.localStorage['status'] && window.localStorage['status'] == 'forgotlink')
      this.otpType = 'password-otp'
    else
      this.otpType = 'activation-otp'
    this.patientservice
      .getuserotp(this.patdetails.userAccountId ? this.patdetails.userAccountId : this.patdetails.userId, this.otpdevice, this.otpType)
      .subscribe(
        data => {
          if (data.status == "success") {
            // ////console.log("message sent")
            this.toast.success(data.message, '', {
              timeOut: this.timealert
            })
            this.validotp = data.value

          } else {
            this.toast.error(data.message, '', {
              timeOut: this.timealert
            })
          }
        }
      )
  }

  otp(msg) {
    let sms = {
      "userAccountId": window.localStorage['randId'],
      "otpassword": this.Patpro.otpassword
    }
    // ////console.log(sms)

    // if(msg.value.otpassword == this.otpid){
    //   this.nav.navigate([`/resetpass/${this.patid.id}`])
    // }
    // else if(msg.value.otpassword != this.otpid){
    //   this.toast.error("OTP Not Matched!")
    // }
    // else{
    //   this.toast.error("Enter OTP again")
    // }
    this.patientservice
      .getotp(sms)
      .subscribe(
        data => {
          if ((data.status == "success") && (data.messasge == "OTP Matched!")) {
            this.toast.success(this.userService.translateText('patient_portal.display_messages.verification_code.correct'), '', {
              timeOut: this.timealert
            })
            this.nav.navigate([`/resetpass`])
          }
          else if ((data.status == "failure")) {
            if (this.patdetails.userGroupId != 19 && this.patdetails.userGroupId != 20) {
              this.error = data.message
            } else {
              this.error = this.userService.translateText('patient_portal.display_messages.verification_code.incorrect')
            }
          }
        }
      )

  }

  validateuser(user) {
    if (user) {
      if (this.userotp == 'email' && user.toLowerCase() == this.patdetails.email.toLowerCase()) {
        this.showOtpValidation = true;
        // this.showotp = true;
        // this.error = '';
        if (!this.patdetails.phone) {
          //   this.otpdevice = this.userotp;
          //   this.reg();
          // }
          // if(this.patdetails.email && this.patdetails.phone){
          //   this.otpdevice = 'both';
          this.reg();
        }
      } else if (this.userotp == 'phone' && this.patdetails.phone && user == this.patdetails.phone.substr(-4, 4)) {
        this.showOtpValidation = true;
        // this.showotp = true;
        // this.error = '';
        if (!this.patdetails.email) {
          //   this.otpdevice = 'sms';
          //   this.reg();
          // }
          // if(this.patdetails.email && this.patdetails.phone){
          //   this.otpdevice = 'both';
          this.reg();
        }
      } else {
        if (!this.patdetails.phone)
          this.error = 'The Email ID entered does not match our records. Please try again'
        else if (!this.patdetails.email)
          this.error = 'The Phone number entered does not match our records. Please try again'
        else {
          if (this.userotp == 'email')
            this.error = 'The Email ID entered does not match our records. Please try again'
          else
            this.error = 'The Phone number entered does not match our records. Please try again'
        }
      }

      // this.patientservice
      //   .getotp(user.value.username)
      //   .subscribe(
      //     data => {

      //     })
    }
  }

  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }

  public customPatterns = { 'A': { pattern: new RegExp('\[a-zA-Z0-9._@+-\]') }, '0': { pattern: new RegExp('\[0-9\]') } };
  Onchange(event) {
    if (event.keyCode != 8 && event.target.value) {
      let targetvalue = event.target.value.replace(/[^a-zA-Z0-9._@+]/g, '');
      let keyvalue = event.key.replace(/[^a-zA-Z0-9._@+]/g, '');
      if ((isNaN(targetvalue) || targetvalue == '') || (isNaN(keyvalue) || keyvalue == '')) {
        this.setmask = "A*"
        this.type = 'email'
      } else
        this.type = 'number'
    }
    else {
      if (event.target.value.length <= 0) {
        this.type = 'email'
        this.setmask = "A*"
      }
    }
    if (this.type == 'email')
      this.Patpro.code = undefined
    else {
      if (this.Patpro.code == '1' || this.Patpro.code == undefined || this.Patpro.code == null) {
        this.Patpro.code = '1'
        this.checkphone('1')
      }
      else {
        this.checkphone(this.Patpro.code)
      }
    }

  }
  checkphone(code) {
    if (this.type == 'number') {
      if (code == "44") {
        this.setmask = '00000 000000'
      } else {
        this.setmask = '(000) 000-0000'
      }
    }

  }
  setvalue() {
    if (this.type != 'number') {
      return false
    } {
      return true
    }
  }



  onOtpChange(otp) {
    this.Patpro.otpassword = otp;
    this.error = ''
  }

  setVal(val) {
    this.ngOtpInput.setValue(val);
  }

  onConfigChange() {
    this.showOtpComponent = false;
    this.Patpro.otpassword = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }

  userotp: any;
  setotppath(event) {
    if (event.target.value) {
      this.userotp = event.target.value
    }
  }

  otpdevice: any;
  setotpdevice(event) {
    if (event.target.value) {
      this.otpdevice = event.target.value
      this.showotp = true
      this.error = ''
      this.reg()
    }
  }
  getvalid(pass) {
    if (pass) {
      let password = pass.split("")
      if (password.length == 6) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  validPreferredOTP() {
    if (this.Patpro.otpassword && !this.getvalid(this.Patpro.otpassword)) {
      let sms = {
        "userAccountId": this.patdetails.userAccountId ? this.patdetails.userAccountId : this.patdetails.userId,
        "otp": btoa(this.Patpro.otpassword),
        "mode": this.otpType
      }
      this.patientservice
        .validOTP(sms)
        .subscribe(
          data => {
            if (data.status == "success") {
              this.toast.success(this.userService.translateText('patient_portal.display_messages.verification_code.correct'), '', {
                timeOut: this.timealert
              })
              window.localStorage['randId'] = data.value
              if (this.patdetails.userGroupId == 19 || this.patdetails.userGroupId == 20) {
                this.nav.navigate([`/createnewpass`])
              } else {
                this.nav.navigate([`/createcarepass`])
              }
            } else {
              if (this.patdetails.userGroupId != 19 && this.patdetails.userGroupId != 20) {
                if (data.invalidCount >= 5) {
                  this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
                  this.expires.componentInstance.message = data.message;
                } else {
                  this.error = data.message
                }
              } else {
                this.error = this.userService.translateText('hospital_portal.disp_messages.invalid_otp.label');
              }
            }
          }
        )
    }
  }

  needHelp() {
    this.userService.loadEmailPopup();
  }
}